import React, { Component } from "react";
import {
  Typography,
  SignUpButton,
  Header,
  BodyText,
  SectionFade,
  Fade,
  FadeUp,
  Background,
  ShopButton,
  ThreeSensorIcons,
  ParticleCanvas,
  LineUpContents,
  PaginationDots,
  CloseButton,
  DismissButton,
  GlowCLogo
} from "../components";

class LineUpGlowContainer extends Component {
  render() {
    const {
      onShopNow,
      onSignUp,
      onClose,
      onSelect,
      isSelected,
      contents,
      commonContents,
      direction,
      OS
    } = this.props;
    const { header, body, prev } = contents;
    const { product, background, timeout } = commonContents;

    const onExited = () => {
      if (direction === "prev") onSelect(prev);
    };

    return (
      <SectionFade
        active={isSelected}
        timeout={timeout.page}
        timing={500}
        onExited={onExited}
      >
        <Background styles={{ backgroundImage: background }} />
        <Header OS={OS}>
          <DismissButton onClick={onClose} />
          <SignUpButton onClick={onSignUp}>{header.signUp}</SignUpButton>
        </Header>
        <BodyText>
          <FadeUp
            timeout={timeout.description}
            timing={500}
            active={isSelected}
          >
            <Typography size={"tiny"} bold styles={{ letterSpacing: "3px" }}>
              {body.description}
            </Typography>
          </FadeUp>
          <FadeUp timeout={timeout.header} timing={500} active={isSelected}>
            <GlowCLogo />
          </FadeUp>
          <FadeUp
            timeout={timeout.header}
            timing={500}
            active={isSelected}
            customStyles={{ display: "flex", flexDirection: "column" }}
          >
            <ThreeSensorIcons isGlow />
            <Typography>{body.feature}</Typography>
          </FadeUp>
        </BodyText>
        <LineUpContents>
          <Fade active={isSelected} timeout={timeout.description} timing={500}>
            <Background
              background={product}
              styles={{ backgroundPosition: "top", backgroundSize: "contain" }}
            />
            <PaginationDots
              OS={OS}
              length={2}
              current={1}
              backgroundColor={"cdd3d8"}
              borderColor={"dee2e5"}
              isAbsolute
            />
          </Fade>
        </LineUpContents>
        <Fade
          active={isSelected}
          timeout={timeout.description}
          timing={500}
          customStyles={{
            height: "auto",
            display: "flex",
            flex: 1,
            flexDirection: "column",
            justifyContent: "center"
          }}
        >
          <ShopButton product={"glow"} onClick={onShopNow}>
            {body.shop}
          </ShopButton>
          <CloseButton onClick={onClose}>{body.close}</CloseButton>
        </Fade>
        <Fade
          active={isSelected}
          timeout={timeout.canvas}
          timing={500}
          customStyles={{ position: "absolute" }}
        >
          {isSelected && <ParticleCanvas particleCount={50} />}
        </Fade>
      </SectionFade>
    );
  }
}

export default LineUpGlowContainer;



// WEBPACK FOOTER //
// ./src/app/intro/containers/LineUpGlowContainer.js